var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recordings-detail-container",class:{ 'is-expanded': _vm.expanded }},[_c(_vm.currentContent,{tag:"component",attrs:{"recording":_vm.recordingObj,"expanded":_vm.expanded},on:{"toMainMenuChild":_vm.toMainMenu,"toggle-expand":function($event){return _vm.$emit('toggle-expand')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71452e16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game-detail/Recordings/RecordingDetailsContainer.vue
// module id = null
// module chunks = 